import React, { useRef } from 'react';
import { useStore } from '../store';
import { Camera, Facebook, Instagram, Trash2 } from 'lucide-react';

interface PhotoPanelProps {
  imageId?: string;
}

export const PhotoPanel: React.FC<PhotoPanelProps> = ({ imageId }) => {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const { imageElements, addImageElement, removeImageElement } = useStore();

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        if (e.target?.result) {
          addImageElement(e.target.result as string);
        }
      };
      reader.readAsDataURL(file);
    }
  };

  const activeImage = imageElements.find(img => img.id === imageId);

  return (
    <div className="space-y-4">
      <input
        type="file"
        ref={fileInputRef}
        onChange={handleFileChange}
        accept="image/*"
        className="hidden"
      />

      {activeImage ? (
        <div className="space-y-4">
          <div className="aspect-video rounded-lg overflow-hidden bg-gray-100">
            <img
              src={activeImage.url}
              alt="Selected"
              className="w-full h-full object-contain"
            />
          </div>
          <button
            onClick={() => removeImageElement(activeImage.id)}
            className="w-full flex items-center justify-center gap-2 px-4 py-3 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors"
          >
            <Trash2 className="w-5 h-5" />
            <span>Supprimer l'image</span>
          </button>
        </div>
      ) : (
        <>
          <button
            onClick={() => fileInputRef.current?.click()}
            className="w-full flex items-center justify-center gap-2 px-4 py-3 border-2 border-dashed border-gray-300 rounded-lg hover:border-gray-400 transition-colors"
          >
            <Camera className="w-5 h-5" />
            <span>Choisissez une photo</span>
          </button>

          <button className="w-full flex items-center justify-center gap-2 px-4 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors">
            <Facebook className="w-5 h-5" />
            <span>Sélectionnez sur Facebook</span>
          </button>

          <button className="w-full flex items-center justify-center gap-2 px-4 py-3 bg-pink-600 text-white rounded-lg hover:bg-pink-700 transition-colors">
            <Instagram className="w-5 h-5" />
            <span>Sélectionnez sur Instagram</span>
          </button>
        </>
      )}
    </div>
  );
};